import * as React from 'react';
import { Button } from 'reactstrap';

class TableHead extends React.Component {
    public render() {
        return (
            <thead>
                <tr>
                    {this.props.children}
                </tr>
            </thead>
        );
    }
}

export default TableHead;